/**
 * Junta clases y descarta lo que no es una.
 *
 * Estaba escrita identica en `apps/app` y en `apps/admin`. No es que se
 * hubieran desincronizado — son cuatro lineas y no tienen como —, pero cada
 * componente que se comparta la va a necesitar, asi que vive donde viven los
 * componentes compartidos.
 */
export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(" ");
}
